/**
 * The bot-mode participant roster (roles and names). Only the bot's owner may
 * change it: salesguru-services refuses set_salesperson / update_participants
 * from anyone else with an `error` frame (services 794364c).
 */
export const ROSTER_COPY = {
  userRoster: 'User Roster',
  editRefused: 'Only the person who added this bot can change its participants.',
  dismiss: 'Dismiss',
  /** "This is me": the owner's own row (macOS `ParticipantRolesSheet`). Local only, never sent. */
  markMe: 'Me',
  markMeHint: 'My lines show as "You"',
} as const;

/**
 * The recall socket sends no id with its `error` frame, so an `error` this soon
 * after a roster edit is read as that edit's refusal; any other is only logged.
 */
export const ROSTER_REFUSAL_WINDOW_MS = 10_000;
